import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";

let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  deferredPrompt = e;
});

function PwaGuide({ size }) {
  const [IosVisible, setIosVisible] = useState(false);
  const [AndroidVisible, setAndroidVisible] = useState(false);

  const installApp = async () => {
    if (deferredPrompt !== null) {
      console.log(deferredPrompt);
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        deferredPrompt = null;
      }
    }
  };

  return (
    <>
      {/*{isMobile && !window.isPwa && (*/}
      <>
        {/* <p style={{ fontSize: "12px" }}>راهنمای نصب PWA</p> */}
        <div className="d-flex justify-content-center py-3">
          <Button
            variant="dark"
            className="ios-btn"
            onClick={() => {
              installApp();
              setAndroidVisible(true);
            }}
          >
            <FontAwesomeIcon icon={faApple} color="#fff" className="mx-1 " />
          </Button>
          <Button
            variant="success"
            className="android-btn"
            onClick={() => {
              installApp();
              setIosVisible(true);
            }}
          >
            <FontAwesomeIcon
              icon={faAndroid}
              color="#fff"
              className="mx-1 crsr-pntr"
            />
          </Button>
        </div>
      </>
      {/*)}*/}
      {/*<IosModal IosVisible={IosVisible} setIosVisible={setIosVisible} />*/}
      {/*<AndroidModal*/}
      {/*    AndroidVisible={AndroidVisible}*/}
      {/*    setAndroidVisible={setAndroidVisible}*/}
      {/*/>*/}
    </>
  );
}

export default PwaGuide;
